import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, InjectedFormProps} from 'redux-form';
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import PageLoader from '../../../shared/components/Loader/PageLoader';
//import { connect, useDispatch, useSelector } from 'react-redux';
//import IState from '../../../core/models/IState';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { validateRequired, validateSelectRequired, validateMaxLength, validateMinLength, validateFirstCharacterWithLength, validateUserIdRequired, validateIAQICCIDAddSensor, validateIAQICCIDMaxLengthAddSensor, validateMinLengthAddSensor, validateMaxLengthAddSensor, validateFirstCharacterWithLengthAddSensor } from '../../../helpers/validation.helper';
import { FormattedMessage } from 'react-intl';
//import { getSensorSelector } from '../../../core/selectors/sensor.selector';
import ReduxFormSelect from '../../../shared/components/ReduxFormHandlers/ReduxFormSelect';
import { IOption } from '../../../models/IReduxFormHandlers';
import QRCodeScanner from './QRCodeScanner';
//import * as actions from '../../../core/actions/actions';
import QRCodeScannerPopupHOC from '../hoc/QrCodeScannerPopupHOC';
import { formatMessage } from '../../../translations/connectedIntlProvider';
import './AddSensorForm.css'
import { toast } from 'react-toastify';

interface IProps {
    id: number;
    isDelete: boolean;
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
    getSensorLoading: boolean;
    addSensorLoading: boolean;
    userList: Array<IOption>;
    sensorTypeList: IOption[];
    QrCodeSubmitHandler: (ScannedIccid:string) => void;
}

const AddSensorForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    //const [showQRCodeScannerPopup,setShowQRCodeScannerPopup] = useState<boolean>(false);
    //const dispatch = useDispatch();

    // const QRCodeScannerToggleHandler = () => {
    //     dispatch(actions.resetGetSensorByIdState());
    //     setShowQRCodeScannerPopup(!showQRCodeScannerPopup);
    // }
    // const openQRCodeScannerHandler = () => {
    //     if (window.location.protocol=="http:")
    //         toast.error(formatMessage("QR_Code_does_not_work_with_http_protocol"));
    //     else
    //         props.QRCodeScannerToggleHandler();
    //   }
    return (
        <React.Fragment>
            {
                props.showQRCodeScannerPopup &&
                <QRCodeScanner
                QrCodeSubmitHandler={props.QrCodeSubmitHandler}
                modalClosed={props.QRCodeScannerToggleHandler} />
            }
            <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.id === -1 ?
                            <FormattedMessage id='Sensor_Title_AddSensor' /> :
                            <FormattedMessage id='Sensor_Title_EditSensor' />}
                    </Modal.Title>
                    {props.getSensorLoading && props.id !== -1 ? <PageLoader /> : null}
                </Modal.Header>

                <form onSubmit={props.handleSubmit((values: any) => props.submitHandler(values))} noValidate>
                    <Modal.Body>
                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_ICCID' /></label>
                            <div className='position-relative w-100'>
                            <Field
                                className="form-control"
                                name="ICCID"
                                component={ReduxFormInput}
                                type="text"
                                disabled={props.id !== -1 ? true : false}
                                min={19}
                                max={20}
                                spaceAllowed={false}
                                validate={[validateRequired("Validation_Required_ICCID"),
                                validateIAQICCIDAddSensor("Validation_ICCID_Numeric"),
                                validateIAQICCIDMaxLengthAddSensor(20,"Validation_ICCID_Max_20"),
                                // validateMinLengthAddSensor(19, 'Validation_ICCID_Min_Char'),
                                // validateMaxLengthAddSensor(20, 'Validation_ICCID_Max_Char'),
                                // validateFirstCharacterWithLengthAddSensor(20, 'Invalid_ICCID'),
                                
                            ]}
                            />
                            { props.id === -1 && 
                                <a title={formatMessage("QR_Code_Scanner")} className="QRCode" data-toggle="modal" onClick={props.QRCodeScannerToggleHandler} data-target="#addSensor">
                                    <svg width="18" height="18" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM3 3h3v3H3V3Zm0 7h3v3H3v-3Zm7-7h3v3h-3V3ZM7 2H2v5h5V2Zm0 7H2v5h5V9Zm2-7h5v5H9V2ZM4 4h1v1H4V4Zm7 0h1v1h-1V4Zm-6 7H4v1h1v-1Zm3.5-3H8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8.5Zm1.5 2V9H9v1h1Zm4 3.5V12h-1v1h-2v1h3v-.5Zm-4 .5v-1H8v1h2Zm2-5h2V8h-2v1Z"/>
                                    </svg>
                                </a>
                            }
                            </div>
                    
                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_CustomerId' /></label>

                            <Field
                                className="form-control"
                                name="CustomerId"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_CustomerId_Max_Char')]}
                            />

                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_Building' /></label>

                            <Field
                                className="form-control"
                                name="Building"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_Building_Max_Char')]}
                            />

                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_Floor' /></label>

                            <Field
                                className="form-control"
                                name="Floor"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_Floor_Max_Char')]}
                            />

                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_Room' /></label>

                            <Field
                                className="form-control"
                                name="Room"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_Room_Max_Char')]}
                            />

                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_Location' /></label>

                            <Field
                                className="form-control"
                                name="Location"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_Location_Max_Char')]}
                            />

                        </div>

                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_Comment' /></label>
                            <Field
                                className="form-control"
                                name="Comments"
                                component={ReduxFormInput}
                                type="text"
                                max={150}
                                validate={[
                                    validateMaxLength(150, 'Validation_Comment_Max_Char')]}
                            />

                        </div>
                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_type' /></label>
                            <Field
                                className="form-control"
                                name="SensorType"
                                component={ReduxFormSelect}
                                isFormatMessage={true}
                                options={props.sensorTypeList}
                                // disabled={props.id !== -1 ? true : false}
                                disabled={true}
                                type="text"
                                validate={[]}
                            />
                        </div>
                        <div className="form-group row">
                            <label className="label-style"><FormattedMessage id='Sensor_Label_User' /></label>
                            <Field
                                className="form-control"
                                name="UserId"
                                component={ReduxFormSelect}
                                options={props.userList}
                                type="text"
                                validate={[validateUserIdRequired("Sensor_Validation_Required_AddUser")]}
                            />

                        </div>
                        {/* <div className="form-group row checkbox">
                            <div className="checkbox-area mt-2">
                                <label>
                                    <Field name="IsIAQSensor" component={ReduxFormInput} type="checkbox" />
                                    <span className="cr">
                                        <i className="cr-icon fas fa-check"></i>
                                    </span>
                                </label>
                                <p><FormattedMessage id='Is_IAQ_Sensor' /></p>
                            </div>
                        </div> */}
                        <div className="form-group row checkbox">
                            <div className="checkbox-area mt-2">
                                <label>
                                    <Field name="SendMail" component={ReduxFormInput} type="checkbox" />
                                    <span className="cr">
                                        <i className="cr-icon fas fa-check"></i>
                                    </span>
                                </label>
                                <p><FormattedMessage id='Send_Mail_Sensor_Location' /></p>
                            </div>
                        </div>

                    </Modal.Body>

                    <div className="modal-footer">
                        <div className="form-group row tab-action">
                            <div className="col-12 px-0">
                                <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                                <LoaderButton type="submit" isLoading={props.addSensorLoading} text={props.id === -1 ? "Button_Save" : "Button_Edit"} />
                            </div>
                        </div>
                    </div>
                </form>

            </Modal>
        </React.Fragment>
    )
}

// const mapStateToProps = (state: IState) => ({
//     initialValues: getSensorSelector(state),
// });


const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'AddSensorForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
        // toast.error(formatMessage('Validation_Correct_error'));
    }
})(AddSensorForm);


export default QRCodeScannerPopupHOC(form);
